export const getGlobalObject = () => global
